import { FC, useState } from 'react'
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useAdminArticleCtas } from '@olagg/api-hooks'
import { IUseArticleCtas } from '@olagg/api-hooks/interfaces/IUseArticleCtas'
import { ArticleCtaType, OlaggModule, PermissionEnum } from '@olagg/db-types'
import Pagination from '@olagg/ui-kit/Pagination'
import { FaPlus } from 'react-icons/fa'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES } from '../../consts/routes'
import useRoles from '../../features/Roles/hooks/useRoles'
import ArticleCtasTable from './Table'

const ArticleCtas: FC = () => {
  const navigate = useNavigate()
  const { missingPermission } = useRoles()
  const [searchParams, setSearchParams] = useSearchParams()
  const [filter, setFilter] = useState<IUseArticleCtas>({
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 10),
  })

  const onFilter = ({ name, value }: { name: string, value: any }) => {
    setFilter({ ...filter, [name]: value })

    if (value) searchParams.set(name, value)
    else searchParams.delete(name)
    setSearchParams(searchParams)
  }

  const { page, limit } = filter
  const { data, deleteArticleCta, updateArticleCta, isLoading } = useAdminArticleCtas(filter)
  const articleCtas = data?.articleCtas
  const count = data?.meta.count

  const toggleActive = (cta: ArticleCtaType) =>
    updateArticleCta(cta.id, { active: !cta.active })

  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>CTAs de Novedades</Heading>
        <Text color='gray.400' fontSize='sm' textAlign='center' maxW='680px'>
          Inventario de los CTAs de la página de artículo. Un CTA activo aparece en el
          siguiente request, sin deploy. Un experimento corre en un solo slot: todos sus
          brazos tienen que compartirlo.
        </Text>

        <Flex w='full' alignItems='center' gap='5'>
          <Button
            mt='2' mb='5'
            display='flex'
            variant='outlinedGradient'
            leftIcon={<FaPlus />}
            onClick={() => navigate(ROUTES.ARTICLE_CTAS.create)}
            isDisabled={missingPermission(OlaggModule.ArticleCta, PermissionEnum.CREATE)}
          >
            Agregar CTA
          </Button>
        </Flex>

        {isLoading ? (
          <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600'>
            <Spinner />
          </Box>
        ) : (
          articleCtas && articleCtas.length > 0 ? (
            <ArticleCtasTable
              articleCtas={articleCtas}
              deleteArticleCta={deleteArticleCta}
              toggleActive={toggleActive}
            />
          ) : (
            <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600'>
              <Text>No hay ningún CTA cargado aún</Text>
            </Box>
          )
        )}

        <Pagination
          params={{ limit, page, count }}
          onClick={page => onFilter({ name: 'page', value: String(page + 1) })}
          onLimitChange={val => onFilter({ name: 'limit', value: val })}
          hideLimitInput
        />
      </VStack>
    </Center>
  )
}

export default ArticleCtas
